module.exports = __webpack_public_path__ + "img/arqu-cabc-05.fcbb45df.jpg";